module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item1-e124c475949c00dcaa1856daf169e851.svg";